import { NavLink, useLocation } from 'react-router-dom';

function AdminSidebar() {
  const location = useLocation();

  const isActive = (page) => {
    // Vérifier si on est sur la route exacte ou si c'est la page par défaut
    if (location.pathname === '/administrator' && page === 'offers') {
      return true;
    }
    return location.pathname === `/administrator/${page}`;
  };

  const menuItems = [
    {
      key: 'offers',
      label: 'Gestion offres',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 shrink-0 fill-current mr-2" width="16" height="16" viewBox="0 0 24 24">
          <path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
        </svg>
      )
    },
    {
      key: 'feed',
      label: 'Gestion Feed',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 shrink-0 fill-current mr-2" width="16" height="16" viewBox="0 0 24 24">
          <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
        </svg>
      )
    },
    {
      key: 'notification',
      label: 'Gestion Notification',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 shrink-0 fill-current mr-2" width="16" height="16" viewBox="0 0 24 24">
          <path fill="currentColor" d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>
        </svg>
      )
    },
    {
      key: 'filters',
      label: 'Gestion Filtres',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 shrink-0 fill-current mr-2" width="16" height="16" viewBox="0 0 24 24">
          <path fill="currentColor" d="M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39A.998.998 0 0 0 18.95 4H5.04a1 1 0 0 0-.79 1.61z"/>
        </svg>
      )
    }
  ];

  return (
    <div className="flex flex-nowrap overflow-x-scroll no-scrollbar md:block md:overflow-auto px-3 py-6 border-b md:border-b-0 md:border-r border-slate-200 dark:border-slate-700 min-w-[15rem] md:space-y-3">
      <div>
        <ul className="flex flex-nowrap md:block mr-3 md:mr-0">
          {menuItems.map((item) => (
            <li key={item.key} className="mr-0.5 md:mr-0 md:mb-0.5">
              <NavLink
                end
                to={`/administrator/${item.key}`}
                className={`flex items-center px-2.5 py-2 rounded whitespace-nowrap transition-colors duration-200 ${
                  isActive(item.key) 
                    ? 'bg-royalblue-50 dark:bg-royalblue-500/30' 
                    : 'hover:bg-slate-50 dark:hover:bg-slate-700/50'
                }`}
              >
                <span className={`${isActive(item.key) ? 'text-royalblue-500 dark:text-royalblue-400' : 'text-slate-400 dark:text-slate-500'}`}>
                  {item.icon}
                </span>
                <span className={`text-sm font-medium ${
                  isActive(item.key) 
                    ? 'text-royalblue-500 dark:text-royalblue-400' 
                    : 'text-slate-600 dark:text-slate-300 hover:text-slate-700 dark:hover:text-slate-200'
                }`}>
                  {item.label}
                </span>
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default AdminSidebar;
